exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{overflow-y:auto!important;overflow-x:hidden}.barcode-row{width:90mm;height:45mm;padding:10px 0;margin-bottom:3px;overflow-y:hidden}.barcode-row:not(:first-child){padding-top:10px}.item p{margin:0;font-size:15px!important;line-height:2.2rem!important}.customer-name{white-space:pre-wrap}#printArea{position:relative;top:50%;background-color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0cb700b8","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/createQrCode.vue
// module id = 587
// module chunks = 0